module.exports = __webpack_public_path__ + "static/media/error.051371b2.svg";